import styled from 'styled-components';

export const Button = styled.button`
    display: inline-block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 37.5px 0 37.5px 65px;
    border-color: transparent transparent transparent var(--color-purple);
    background-color: transparent;
`;
